<template>
	<div v-if='banners.length > 0'>
		<div class='catalog-container shadow mb-3 rounded-lg'>
			<v-carousel
				:show-arrows='false'
				hide-delimiters
				:show-arrows-on-hover='false'
				height='auto'
				class='catalog-banner-carousel rounded-lg'
				:cycle='false'
			>
				<v-carousel-item
					v-for='banner in banners'
					:key='banner._uid'
					:src='getBannerImage(banner)'
					reverse-transition='fade-transition'
					transition='fade-transition'
					:href='getBannerUrl(banner)'
					class='rounded-lg'
				/>
			</v-carousel>
		</div>
	</div>
</template>

<script>

export default {
  name: 'CatalogBannerCarousel',
  data () {
    return {
      banners: [],
      window: {
        height: 0,
        width: 0
      }
    }
  },

  mounted () {
    this.getBanners ()
  },

  created () {
    window.addEventListener ('resize', this.handleResize)
    this.handleResize ()
  },

  destroyed () {
    window.removeEventListener ('resize', this.handleResize);
  },

  methods: {
    getBanners () {
      this.$storyapi.get ('cdn/stories/de-de/globals/katalog-banner', {})
          .then ((res) => {
            this.banners = res.data.story.content.global
          })
          .catch ((err) => {
            console.log (err)
          })
    },
    getBannerUrl (banner) {
      if (typeof banner.link !== 'undefined') {
        return banner.link.url
      }

      return '#'
    },

    getBannerImage (banner) {
      if (this.window.width >= 600) {
        return banner.img_desktop.filename
      }
      return banner.img_mobile.filename
    },

    handleResize () {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
}
</script>

<style scoped lang="scss">
</style>
